import { useTelegramConfigsFindOneByKey } from '@/generated';
import { useMemo, useState } from 'react';

export const useMobileAppLinks = () => {
  const { isLoading, data } = useTelegramConfigsFindOneByKey('MOBILE_APPS');
  const [hasError, setHasError] = useState(false);

  const dataConverted = useMemo(() => {
    if (isLoading) {
      return {};
    }
    if (!data) {
      setHasError(true);
      return;
    }
    try {
      const converted = JSON.parse(data.data);
      return converted;
    } catch (e) {
      setHasError(true);
      return;
    }
  }, [data, isLoading]);

  return {
    isLoading,
    data: dataConverted,
    hasError,
  };
};
